import axiosInstances from '@/../../coreui/server/axiosInstances'

async function getHarvest(active) {
    console.log("Getting the harvest")
    let res = null
    if (active === "yes") {
        res = await axiosInstances.apiServer.get('/dt/v1/cul_harvest?IsUsed=yes&return=name')
    }
    else {
        res = await axiosInstances.apiServer.get('/dt/v1/cul_harvest?return=name')
    }
    console.log(res)
    return res.data
}

async function buildSelect(active, definition, reportParams){
    let obj = {}
    obj["active"] = active
    obj["def"] = definition
    obj["params"] = reportParams
    console.table(definition)
    let result = null
    result = await axiosInstances.reportServer.post('/buildselect', obj)
    return result.data
}

async function getSelection(filterDefinitionSrc, reportType, reportParams) {
    console.log("Getting the selection")
    let filterDefinition = JSON.parse(JSON.stringify(filterDefinitionSrc))
    console.table(filterDefinition)
    let nameList = null
    if (filterDefinition.widget === "dynamic_select") {
        nameList = await buildSelect(reportType, filterDefinition, reportParams)
    } else {
        nameList = []
        switch (filterDefinition.src) {
            case "table":
                switch (filterDefinition.name) {
                    case "cul_harvest":
                        let selection = await getHarvest(reportType)
                        for (const item of selection) {
                            nameList.push(item[filterDefinition.field])
                        }
                        break
                    default:
                        break
                }
                break
            case "options":
                console.log("IN the options choice")
                for (const item of filterDefinition.options) {
                    console.log(`item = ${item}`)
                    nameList.push(item)
                }
                break
            default:
                break
        }
    }
    filterDefinition["items"] = nameList
    return filterDefinition
}

async function getReport(reportName, reportParameters) {
    console.log(`Report name = ${reportName}`)
    console.log(`Report Parameters = ${reportParameters}`)
    reportParameters.push({ 'src': "reportType", 'value': reportName })
    let res = await axiosInstances.reportServer.post('/cultivation', reportParameters)
    return res
}

async function getReportList(table) {
    let response = await axiosInstances.loginServer.get(`/dt/v1/${table}`)
    let reportList = response.data
    console.log("Report List")
    console.dir(reportList)
    return reportList
}

export default {
    getSelection,
    getReport,
    getReportList
}
